import { SeverityWithText } from '@root/components/bootstrapTable/badges/severity';
import commonTableColumns from '@root/components/table/commonTableColumns';
// import CountTooltip from '@root/components/Tooltip/CountTooltip';
import Text from '@root/components/v2/ui-elements/Text';
import Tooltip from '@root/components/v2/ui-elements/Tooltip';
import { isEmpty } from 'lodash';
// import EllipsesCountTooltip from '@root/components/v3/ellipsesCountTooltip';
// import { VulnerabilityCounts } from '../VulnerabilityCounts';
// import { Box } from '@mui/material';

export const sbomColumns = [
  commonTableColumns.environment('account_id', 'cluster'),
  {
    field: 'image_name',
    headerName: 'Image',
    width: 300,
    renderCell: params => {
      return (
        <Tooltip title={params.row.image_name}>
          <Text className="SingleLine" fontWeight={500}>
            {isEmpty(params.row.image_name) ? '-' : params.row.image_name}
          </Text>
        </Tooltip>
      );
    },
  },
  {
    field: 'wlid',
    headerName: 'Workload ID',
    renderCell: params => {
      return (
        <Tooltip title={params.row.wlid}>
          <Text className="SingleLine" fontWeight={500}>
            {isEmpty(params.row.wlid) ? '-' : params.row.wlid}
          </Text>
        </Tooltip>
      );
    },
    width: 250,
  },

  {
    field: 'namespace',
    headerName: 'Namespace',
    width: 200,
    renderCell: params => {
      return (
        <Tooltip title={params.row.namespace}>
          <Text className="SingleLine" fontWeight={500}>
            {isEmpty(params.row.namespace) ? '-' : params.row.namespace}
          </Text>
        </Tooltip>
      );
    },
  },
  {
    field: 'registry',
    headerName: 'Registry',
    width: 200,
    renderCell: params => {
      return (
        <Tooltip title={params.row.registry}>
          <Text className="SingleLine" fontWeight={500}>
            {isEmpty(params.row.registry) ? '-' : params.row.registry}
          </Text>
        </Tooltip>
      );
    },
  },
  {
    field: 'error_type',
    headerName: 'Error Type',
    width: 200,
    renderCell: params => {
      return (
        <Tooltip title={params.row.error_message} isIcon={true}>
          <Text className="SingleLine" fontWeight={500}>
            {isEmpty(params.row.error_type) ? '-' : params.row.error_type}
          </Text>
        </Tooltip>
      );
    },
  },
  {
    field: 'severity',
    headerName: 'Error Severity',
    width: 200,
    renderCell: params => {
      return <SeverityWithText propsValue={params.row.severity} />;
    },
  },
];
